import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';

export const negSingleCarrierValidationSet: ValidationPair = {
  children: {
    shared: {
      children: {
        patientGender: {
          validators: [Validators.required],
        },
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        patientInformation: {
          children: {
            documentNumber: {
              validators: [Validators.required],
            },
            ethnicity: {
              validators: [Validators.required],
            },
            ethnicitySelect: {
              validators: [Validators.required],
            },
          },
        },
        patientHistory: {
          children: {
            boneMarrowTransplant: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
              },
            },
          },
        },
      },
    },
  },
};
